import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Heritage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "heritage";
    }
}

export function Heritage$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Heritage", void 0, Heritage, Metadata_StringCategory$reflection());
}

export function Heritage_$ctor_Z721C83C5(aName) {
    return new Heritage(aName);
}

export class RecordingYear extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "recording_year";
    }
}

export function RecordingYear$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.RecordingYear", void 0, RecordingYear, Metadata_NumberCategory$reflection());
}

export function RecordingYear_$ctor_Z721C83C5(aName) {
    return new RecordingYear(aName);
}

export class Birth extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth";
    }
}

export function Birth$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Birth", void 0, Birth, Metadata_StringCategory$reflection());
}

export function Birth_$ctor_Z721C83C5(aName) {
    return new Birth(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Age extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Age", void 0, Age, Metadata_StringCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class Decade extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "decade";
    }
}

export function Decade$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Decade", void 0, Decade, Metadata_StringCategory$reflection());
}

export function Decade_$ctor_Z721C83C5(aName) {
    return new Decade(aName);
}

export class Place extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place";
    }
}

export function Place$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Place", void 0, Place, Metadata_StringCategory$reflection());
}

export function Place_$ctor_Z721C83C5(aName) {
    return new Place(aName);
}

export class Area extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "area";
    }
}

export function Area$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Area", void 0, Area, Metadata_StringCategory$reflection());
}

export function Area_$ctor_Z721C83C5(aName) {
    return new Area(aName);
}

export class Region extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "region";
    }
}

export function Region$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Region", void 0, Region, Metadata_StringCategory$reflection());
}

export function Region_$ctor_Z721C83C5(aName) {
    return new Region(aName);
}

export class Country extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "country";
    }
}

export function Country$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Country", void 0, Country, Metadata_StringCategory$reflection());
}

export function Country_$ctor_Z721C83C5(aName) {
    return new Country(aName);
}

export class Notes extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "notes";
    }
}

export function Notes$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Notes", void 0, Notes, Metadata_StringCategory$reflection());
}

export function Notes_$ctor_Z721C83C5(aName) {
    return new Notes(aName);
}

export class EnglishWhen extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "english_when";
    }
}

export function EnglishWhen$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.EnglishWhen", void 0, EnglishWhen, Metadata_StringCategory$reflection());
}

export function EnglishWhen_$ctor_Z721C83C5(aName) {
    return new EnglishWhen(aName);
}

export class SchoolLanguage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "school_language";
    }
}

export function SchoolLanguage$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.SchoolLanguage", void 0, SchoolLanguage, Metadata_StringCategory$reflection());
}

export function SchoolLanguage_$ctor_Z721C83C5(aName) {
    return new SchoolLanguage(aName);
}

export class ConfirmationLanguage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "confirmation_language";
    }
}

export function ConfirmationLanguage$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.ConfirmationLanguage", void 0, ConfirmationLanguage, Metadata_StringCategory$reflection());
}

export function ConfirmationLanguage_$ctor_Z721C83C5(aName) {
    return new ConfirmationLanguage(aName);
}

export class ScandinavianContact extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "scandinavian_contact";
    }
}

export function ScandinavianContact$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.ScandinavianContact", void 0, ScandinavianContact, Metadata_StringCategory$reflection());
}

export function ScandinavianContact_$ctor_Z721C83C5(aName) {
    return new ScandinavianContact(aName);
}

export class VisitsScandinavia extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "visits_scandinavia";
    }
}

export function VisitsScandinavia$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.VisitsScandinavia", void 0, VisitsScandinavia, Metadata_StringCategory$reflection());
}

export function VisitsScandinavia_$ctor_Z721C83C5(aName) {
    return new VisitsScandinavia(aName);
}

export class ReadingScandinavian extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "reading_scandinavian";
    }
}

export function ReadingScandinavian$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.ReadingScandinavian", void 0, ReadingScandinavian, Metadata_StringCategory$reflection());
}

export function ReadingScandinavian_$ctor_Z721C83C5(aName) {
    return new ReadingScandinavian(aName);
}

export class L1Or2 extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "l_1_or_2";
    }
}

export function L1Or2$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.L1Or2", void 0, L1Or2, Metadata_StringCategory$reflection());
}

export function L1Or2_$ctor_Z721C83C5(aName) {
    return new L1Or2(aName);
}

export class GPlace extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "g_place";
    }
}

export function GPlace$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.GPlace", void 0, GPlace, Metadata_StringCategory$reflection());
}

export function GPlace_$ctor_Z721C83C5(aName) {
    return new GPlace(aName);
}

export class GCounty extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "g_county";
    }
}

export function GCounty$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.GCounty", void 0, GCounty, Metadata_StringCategory$reflection());
}

export function GCounty_$ctor_Z721C83C5(aName) {
    return new GCounty(aName);
}

export class GGeneration extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "g_generation";
    }
}

export function GGeneration$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.GGeneration", void 0, GGeneration, Metadata_StringCategory$reflection());
}

export function GGeneration_$ctor_Z721C83C5(aName) {
    return new GGeneration(aName);
}

export class GEmigrated extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "g_emigrated";
    }
}

export function GEmigrated$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.GEmigrated", void 0, GEmigrated, Metadata_StringCategory$reflection());
}

export function GEmigrated_$ctor_Z721C83C5(aName) {
    return new GEmigrated(aName);
}

export class GNotes extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "g_notes";
    }
}

export function GNotes$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.GNotes", void 0, GNotes, Metadata_StringCategory$reflection());
}

export function GNotes_$ctor_Z721C83C5(aName) {
    return new GNotes(aName);
}

export class Genre extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "genre";
    }
}

export function Genre$reflection() {
    return class_type("Corpora.Cans3.MetadataCategories.Genre", void 0, Genre, Metadata_StringCategory$reflection());
}

export function Genre_$ctor_Z721C83C5(aName) {
    return new Genre(aName);
}

